<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="svgWidth" :height="svgHeight" viewBox="0 0 19.956 11.978" :class="iconCssClass">
    <g data-id="btn-collapse-expand" transform="translate(17.128 9.978) rotate(180)">
      <path data-id="Path_2" data-name="Path 2" d="M718,462.424l7.15-7.15,7.15,7.15" transform="translate(-718.004 -455.275)" :fill="getFill"  :stroke="getStroke" stroke-linecap="round" stroke-linejoin="round" :stroke-width=svgStrokeWidth />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'chevronDown',
    props: ['iconSize', 'iconFill', 'iconStroke', 'iconCssClass'],
    data() {
      return {
        svgWidth: "19.956",
        svgHeight: "11.978",
        svgFill: "none",
        svgStroke: "#236c6c",
        svgStrokeWidth: "4"
      }
    },
    computed: {
      getSize() {
        if (this.iconSize != undefined && this.iconSize !== "") {
          const multiplier = this.iconSize * 1
          this.svgWidth = this.svgWidth * multiplier
          this.svgHeight = this.svgHeight * multiplier
        }
      },
      getFill() {
        if (this.iconFill !== undefined && this.iconFill !== "") {
          return this.svgFill = this.iconFill
        }
        return this.svgFill
      },
      getStroke() {
        if (this.iconStroke !== undefined && this.iconStroke !== "") {
          this.svgStroke = this.iconStroke
        }
        return this.svgStroke
      }
    },
    mounted() {
      this.getSize
      this.getStroke
    }
  }
</script>
